import styled from "styled-components";

export const ObjectHeaderDiv = styled.div`
  min-width: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  border-bottom: var(--border);
  padding-bottom: var(--gap);
  margin-bottom: var(--gap);
  box-sizing: border-box;
  & h2 {
    margin: 0;
    font-weight: bold;
    display: flex;
    justify-content: space-between;
    & em {
      font-weight: normal;
    }
  }
  & h3 {
    margin: 0;
  }
`;
